/**
 * @generated SignedSource<<a5b5a6c4b5777d3ba4ef49bb4ac0b8f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SquareGiftCardStatus = "ACTIVE" | "BLOCKED" | "DEACTIVATED" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type RainchecksList_customer$data = {
  readonly availableRainchecks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly squareGiftCard: {
          readonly balance: number;
          readonly id: string;
          readonly status: SquareGiftCardStatus;
        };
        readonly " $fragmentSpreads": FragmentRefs<"Raincheck_raincheck">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly usedRainchecks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly squareGiftCard: {
          readonly balance: number;
          readonly id: string;
          readonly status: SquareGiftCardStatus;
        };
        readonly " $fragmentSpreads": FragmentRefs<"Raincheck_raincheck">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RainchecksList_customer";
};
export type RainchecksList_customer$key = {
  readonly " $data"?: RainchecksList_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RainchecksList_customer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RaincheckEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Raincheck",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Raincheck_raincheck"
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareGiftCard",
            "kind": "LinkedField",
            "name": "squareGiftCard",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "balance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "redeemableAtFacilityId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RainchecksList_customer",
  "selections": [
    {
      "alias": "availableRainchecks",
      "args": [
        {
          "kind": "Literal",
          "name": "expired",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "giftCardIsActive",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "hasNonZeroBalance",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "redeemableAtFacilityId",
          "variableName": "redeemableAtFacilityId"
        }
      ],
      "concreteType": "RaincheckConnection",
      "kind": "LinkedField",
      "name": "rainchecks",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "usedRainchecks",
      "args": [
        {
          "kind": "Literal",
          "name": "hasNonZeroBalance",
          "value": false
        }
      ],
      "concreteType": "RaincheckConnection",
      "kind": "LinkedField",
      "name": "rainchecks",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "rainchecks(hasNonZeroBalance:false)"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "577cfc1a971597f87b2b90d7f7cff42f";

export default node;
